import { prepareIcon } from '../components/icon-transform.js';

import addRaw from '../../../../docs/design-system/assets/icons/add_line.svg?raw';
import attentionRaw from '../../../../docs/design-system/assets/icons/attention_line.svg?raw';
import completeRaw from '../../../../docs/design-system/assets/icons/complete_line.svg?raw';
import documentsRaw from '../../../../docs/design-system/assets/icons/documents_line.svg?raw';
import historyRaw from '../../../../docs/design-system/assets/icons/history_line.svg?raw';
import informationRaw from '../../../../docs/design-system/assets/icons/information_line.svg?raw';
import meRaw from '../../../../docs/design-system/assets/icons/me_line.svg?raw';

/**
 * **ブラウザ側のアイコン**（`docs/design-system.md` §3.4 / D97）。
 *
 * ## `?raw` で読む理由
 *
 * `components/icons.ts` は `node:fs` を使うので**ブラウザでは動かない**。
 * `Icon` のコメントが「**呼び出し側がビルド時に読み込んだ文字列を渡す**」と
 * 書いているのは、**この module のこと**である。
 *
 * ## 原本をそのまま置いた場所から読む
 *
 * **コピーを作らない** — `docs/design-system/assets/` は
 * **デジタル庁の配布物をそのまま置いた場所**であり、
 * **加工済みの複製を `apps/web` に作ると「配布物と同じか」が分からなくなる**
 * （`globals.css` が `ua-tokens.css` を直接読んでいるのと同じ理由）。
 *
 * ## 使う分だけ持つ
 *
 * **17 件を全部束ねない** — **使わないアイコンはバンドルに入れない**。
 * 足すときはここに 1 行足す。
 */
export const ICONS = {
  /** 新しい問題を始める */
  add: prepareIcon(addRaw),
  /** 失敗・注意（`ErrorBanner` / 理解の状態の「まだ確認中」） */
  attention: prepareIcon(attentionRaw),
  /** 理解できている */
  complete: prepareIcon(completeRaw),
  /** これまでの問題の 1 件 */
  documents: prepareIcon(documentsRaw),
  /** 履歴の見出し */
  history: prepareIcon(historyRaw),
  /** 注意書き（D13 の 2 点） */
  information: prepareIcon(informationRaw),
  /** 学習者自身 */
  me: prepareIcon(meRaw),
} as const;

export type IconName = keyof typeof ICONS;
